const SupportPage = () => {};

export default SupportPage;
